import { WritableSignal, signal, inject } from '@angular/core';
import { StandardDropdown } from '../../../../../../shared/models/components/dropdowns/standardDropdown.models';
import { FeedbackService } from '../../../../../../shared/services/componentsServices/feedback.service';
import { currentFeedbackModel } from '../../../../../../shared/models/serviceModels/request/feedbackReq.model';
import { feedbackFormsData } from '../../../../../../shared/models/serviceModels/response/feedbackRes.model';
import { RunData } from './prediction-selector/prediction-selector.component';

export abstract class BaseFeedbackFormComponent {
  protected feedbackService = inject(FeedbackService);

  predictionDropdown: WritableSignal<StandardDropdown[]> = signal([]);
  runsData: WritableSignal<RunData[]> = signal([]);
  feedbackFormData: WritableSignal<feedbackFormsData | null> = signal(null);

  protected abstract givenFeedbackResponse: currentFeedbackModel;
  protected abstract getPredictionData?(): void;

  /**
   * Sets the runs list by user from the feedback service
   */
  protected setRunsListByUser(): void {
    const runsDataByUser = this.feedbackService.getRunsDataByUser()();

    if (runsDataByUser?.errorMsg || !runsDataByUser?.runs || runsDataByUser.runs.length === 0) return;

    // Set runsData for the new prediction-selector component
    const runs: RunData[] = runsDataByUser.runs.map(run => ({
      id: run.id,
      run_date: run.run_date,
      relatedRunIds: run.relatedRunIds
    }));
    this.runsData.set(runs);

    // Keep the old dropdown for backward compatibility (if needed)
    let runsList: StandardDropdown[] = [];
    runsDataByUser?.runs?.forEach(run => {
      const runDate = new Date(run.run_date);
      const formattedDate = runDate.toLocaleDateString('en-US');
      runsList.push({ description: formattedDate, value: run.id.toString() });
    });
    this.predictionDropdown.set(runsList);
  }

  /**
   * Handler for the prediction-selector component
   */
  protected onRunSelected(runData: RunData): void {
    let formData = this.feedbackFormData();

    this.givenFeedbackResponse = {
      ...this.givenFeedbackResponse,
      predictionSourceTypeId: formData?.predictionSourceType?.feedbackFieldValues?.find(
        type => type.field?.toLowerCase().trim() === "prediction".toLowerCase()
      )?.id,
      predictionRunId: Number(runData.id),
      predictionRunDate: new Date(runData.run_date),
      relatedRunIds: runData.relatedRunIds
    };

    this.feedbackService.setFeedbackValues(this.givenFeedbackResponse!);
    
    if (this.getPredictionData) {
      this.getPredictionData();
    }
  }
}
